import React from "react";

const Card = ({ data }) => {
    console.log(data.card[0].bg);

    return (
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 ">
            {
                data.card.map((card, index) => (
                    <div className="flex flex-col gap-5" key={index}>    
                        <div 
                            className="flex border-solid justify-between rounded-3xl bg-no-repeat bg-cover bg-top p-5" 
                            style={{ backgroundImage: `url(${card.bg}) `}} // Исправлено здесь
                        >
                            <div className="flex flex-col font-medium gap-2 mt-80">
                                <div className="flex border-solid items-center gap-2 rounded-3xl px-4 py-1 w-fit" style={{ backgroundColor: card.bg_title }}>
                                    <span className="w-1 h-1 rounded-full" style={{ backgroundColor: card.color_dote }}></span>
                                    <span className="text-[14px]" style={{ color: card.color_title }}>{card.title}</span>
                                </div>
                                <span className="border-solid rounded-3xl px-4 py-1 w-fit text-[14px]" style={{ color: card.color_date, backgroundColor: card.bg_date }}>{card.date}</span>
                            </div>
                        
                            <button className="red-custom-button flex border-solid rounded-full w-12 h-12 items-center justify-center" onClick={() => window.location.replace(card.source_url)}>
                                <img src={card.link} alt="arrow"/>
                            </button>
                        </div>

                        <span className="md:text-[28px] text-[24px] font-medium leading-tight" style={{ color: card.color_description }}>{card.description}</span>
                    </div> 
                ))
            }
        </div>
    );
};

export default Card;
